import { render, staticRenderFns } from "./Step_5.vue?vue&type=template&id=0fb13c9e&scoped=true"
import script from "./Step_5.vue?vue&type=script&lang=js"
export * from "./Step_5.vue?vue&type=script&lang=js"
import style0 from "./Step_5.vue?vue&type=style&index=0&id=0fb13c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb13c9e",
  null
  
)

export default component.exports